// extracted by mini-css-extract-plugin
export default {"textContainer":"aboutus_textContainer__eTPic","overlay":"aboutus_overlay__Y0oyA","orbiowaycontainer":"aboutus_orbiowaycontainer__yUXJS","orbioContent":"aboutus_orbioContent__xAixI"};